// Maps internal section ids to short, user-friendly labels
// used by the "Resume where you left off" banner.
export const SECTION_LABELS = {
  // Manifesto
  'about': 'Our Stance',

  // Project / My Project
  'project': 'My Project',
  'my-project-dashboard': 'My Project Dashboard',
  'project-rera': 'RERA Project Info',
  'project-rera-public': 'RERA Project Info',
  'project-litigation': 'Litigation',
  'project-living': 'Post-OC: Issues & Resolution',
  'project-overview': 'Overview',
  'project-delivery': 'Delivery Risk',
  'project-money': 'Financial Details',
  'project-story': 'Project Story',
  'project-archive': 'Archive & Vault',
  'project-dev-info': 'Developer Assurances',
  'project-dev-im': 'Information Memorandum',
  'project-dev-details': 'Project Details',
  'project-dev-tracking': 'Project Progress Tracking',
  'project-dev-engagement': 'Developer Engagement',
  'project-buyer-info': 'RERA Records',
  'project-buyer-dd': 'Due Diligence',
  'project-buyer-obs': 'Observations',
  'project-buyer-voice': 'Buyer\u2019s Voice',
  'project-dossier': 'Project Dossier',
  'project-details': 'Project Details',
  'project-record': 'RERA Public Record',
  'corpus-warroom': 'Corpus Issues',
  'project-progress': 'Project Progress',

  // Prospective
  'browse-projects': 'Explore Projects',
  'emi-calculator': 'EMI Calculator',
  'buyers-journey': 'Buyer\u2019s Journey',
  'pb-site-visit': 'Site Visit Booking',
  'pb-callback': 'Callback Request',
  'pb-brochure': 'Brochure Download',
  'pb-connect-buyers': 'Connect with Buyers',
  'pb-dd-request': 'Due Diligence Request',
  'pb-legal': 'Legal Consultation',
  'pb-loan': 'Loan Facilitation',
  'pb-registration': 'Registration Guide',

  // Me / Us
  'me': 'Profile',
  'my-documents': 'My Documents',
  'subscription': 'FBC Membership',
  'us': 'Buyers\u2019 Group',
  'us-directory': 'Directory',
  'us-correspondence': 'Correspondence',
  'us-notices': 'Notices',
  'us-threads': 'Threads',
  'us-meetings': 'Meetings',
  'us-s18-collective': 'S.18 Collective',

  // Content
  'knowledge': 'Expert Guidance & Education',
  'videos': 'Expert Guidance & Education',
  'education': 'Expert Guidance & Education',
  'my-submissions': 'My project requests',
  'buyer-resources': 'Free Buyer Resources & Legal Reference',
  'news': 'Real Estate News & Analysis',

  // Services
  'professional': 'Professional Services',
  'toolkit': 'Due Diligence Toolkit',
  'legal-services': 'S.18 Legal Services',
  'subvention-claims': 'Subvention & Pre-EMI Claims',
  'service-providers': 'Find Independent Professionals',

  // Facets
  'recourse-landing': 'Rights and Options',
  'buying-landing': 'Buying Smart',
  'learn-landing': 'Knowledge Hub',
  'risk-landing': 'Buyer\u2019s Checklist',
  'community-landing': 'Buyers\u2019 Group',
  'services-landing': 'Services',
  'developer-landing': 'Developer Updates',

  // Due diligence topics
  'quality-issues': 'Quality Issues',
  'title-dd': 'Title & Legal Clarity',
  'statutory-dd': 'Approval & Regulatory Status',
  'financial-dd': 'Financial Health Visibility',
  'loan-subvention-safety': 'Loan & Subvention Safety',
  'group-buying': 'Group Buying',
  'verify-ownership': 'Verify Ownership',

  // Developer
  'dev-my-projects': 'My Projects',
  'dev-verifications': 'Buyer Verifications',
  'dev-post-updates': 'Post Updates',
  'dev-issues': 'Project Issues',
  'developer-directory': 'Developer Directory',
  'developer-featured': 'Featured Developers',
  'developer-leaderboard': 'Developer Leaderboard',
  'developer-register': 'Developer Registration',
  'developer-approval': 'Developer Approvals',
  'developer-console': 'Developer Console',

  // Owner Services
  'property-marketplace': 'Property Marketplace',
  'list-property': 'List Property',
  'my-listings': 'My Listings',
  'home-services': 'Home Services',

  // Possession
  'pre-possession': 'Pre-Possession',
  'post-possession': 'Post-Possession Issues',
  'post-possession-rights': 'Post-Possession Rights',

  // LMS
  'lms-dashboard': 'Lead Dashboard',
  'lms-admin': 'Lead Management (Admin)',

  // Role
  'professional-dashboard': 'Professional Dashboard',
  'admin': 'Admin Panel',

  // Lawyer
  'lawyer-dashboard': 'Lawyer Dashboard',
  'get-help': 'Where to start',
  'triage': 'Where to start',
  'sitemap': 'Site Map',
  'project-request': 'Project request',
  'lawyer-registration': 'Lawyer Registration',
};

export function getSectionLabel(sectionId) {
  if (!sectionId) return null;
  return SECTION_LABELS[sectionId] || null;
}
